export default class NewsCreateRequest {
    constructor(locale, supportedLocales) {        
        this.translations = [];
        supportedLocales.forEach(element => {
            this.translations[element] = {
                title : '',        
                description : '&nbsp'        
            };
        });
        
        this.coinsToEarn = null; 
        this.activeFrom = null;
        this.activeTo = null;
    }

    static assign(from, to) {
        if (from) {
            to.locale = from.locale;
            to.title = from.title;
        } else {
            to = new NewsCreateRequest();
        }
    }

    static copy(from) {
        const to = new NewsCreateRequest();
        NewsCreateRequest.assign(from, to);
        return to;
    }
}
